import React from 'react'
import { ReferencePicker } from './ReferencePicker'
import { optionLabelOf, useMeetingTemplateOptions } from './referenceOptionSources'
import { type ReferenceValueLabelProps, type ZocksReferenceWidgetProps } from './registry'

export const MeetingTemplateWidget: React.FC<ZocksReferenceWidgetProps> = (props) => {
  const { options, loading } = useMeetingTemplateOptions()
  return <ReferencePicker {...props} options={options} loading={loading} />
}

export const MeetingTemplateValueLabel: React.FC<ReferenceValueLabelProps> = ({ value, fallback }) => (
  <>{optionLabelOf(useMeetingTemplateOptions(), value, fallback)}</>
)
